var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.steps},_vm._l((_vm.list),function(step,$index){
var _obj;
return _c('div',{key:$index + 1,class:[_vm.$style.step, ( _obj = {}, _obj[_vm.$style['is-process']] = $index + 1 === _vm.active, _obj )]},[_c('div',{class:_vm.$style.step__number},[_vm._v(_vm._s($index + 1))]),_c('div',{class:_vm.$style.step__main},[_vm._v(_vm._s(step.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }